import { Injectable } from '@angular/core';

import { WorkTimeService } from './work-time.service';

@Injectable()
export class HeaderService {
  isSidebarFlag = true;
  isTaskbarFlag = true;
  isUsernameFlag = true;

  constructor(public workTime: WorkTimeService) {}

  showSideMenu(): void {
    this.isSidebarFlag = true;
  }

  showTaskMenu(): void {
    this.isTaskbarFlag = true;
  }

  hideSideMenu(): void {
    this.isSidebarFlag = false;
  }

  hideTaskMenu(): void {
    this.isTaskbarFlag = false;
  }

  showUsername(): void {
    this.isUsernameFlag = true;
  }

  hideUsername(): void {
    this.isUsernameFlag = false;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/header.service.ts